import ConfirmationModal from '@components/ItemPage/Details/Notifications/ConfirmationModal'
import styles from '../../../../elements/BidSwitch/BidSwitch.module.scss'
import { MdEmail, MdTextsms } from 'react-icons/md'

const Switch = ({
  name,
  label = name,
  value,
  handleSwitch,
  disabled,
}: {
  name: 'SMS' | 'Email'
  label?: string
  value: boolean
  disabled: boolean
  handleSwitch: (switchName: string) => Promise<void>
}) => {
  return (
    <div className="flex items-center justify-between px-1">
      <span className="text-xs font-bold flex gap-2 items-center">
        {name === 'SMS' ? (
          <MdTextsms size={16} className="text-bidfta-blue-backdrop-light" />
        ) : (
          <MdEmail size={16} className="text-bidfta-yellow-light" />
        )}
        <span> {label}</span>
      </span>

      {disabled ? (
        <div>
          <ConfirmationModal notificationType={name}>
            <button className="rounded-full bg-bidfta-blue-dark text-white font-bold text-xs py-1 px-4">
              Enable {name} Notifications
            </button>
          </ConfirmationModal>
        </div>
      ) : (
        <div className={'flex flex-col'}>
          <div className={`${styles.switchWrapper}`}>
            <input
              type="checkbox"
              name={`${name}-switch`}
              className={`${styles.mobileSwitch}`}
              id={`${name}-switch`}
              checked={!!(value ? 'checked' : '')}
              readOnly
            />
            <label
              htmlFor={`${name}-switch`}
              className={'cursor-pointer text-black'}
              onClick={() => handleSwitch(name)}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Switch
